<div class="sidebar-wrapper">
  <app-sidebar-header (backButtonClicked)="goToPreviousPage()" [showBackButton]="currentPage() !== 1">
    <div smallTitle>{{ isEdit() ? 'Edit' : 'Add' }} Prime Invoice</div>
    @switch (currentPage()) {
      @case (1) {
        <div mainTitle>General Information</div>
      }
      @case (2) {
        <div mainTitle class="flex justify-between items-center">
          <div>{{ model()?.invoice_number ?? 'Invoice' }} Detail</div>
          <div class="flex items-center gap-2">
            <div class="capitalize">Hide zero dollars SOV</div>
            <app-checkbox [(ngModel)]="hideZeroDollarSov" (onChange)="onHideZeroDollarSovChange($event)"></app-checkbox>
          </div>
        </div>
      }
    }
  </app-sidebar-header>
  <div class="main-content m-0 p-0 flex flex-col">
    @if (isLoading()) {
      <app-page-loading class="relative"></app-page-loading>
    } @else if (currentPage() === 1) {
      <app-prime-invoice-sidebar-general></app-prime-invoice-sidebar-general>
    } @else if (currentPage() === 2) {
      <app-prime-invoice-sidebar-detail></app-prime-invoice-sidebar-detail>
    }
  </div>
  <div class="buttons flex justify-end gap-4">
    @if (currentPage() === 1) {
      <app-simple-button [disabled]="primeInvoiceStore?.firstPageForm()?.form?.invalid" (click)="goToNextPage()"
        >Next
      </app-simple-button>
    } @else {
      <app-simple-button (click)="save()" buttonStyle="color_accent_filled">Save</app-simple-button>
    }
  </div>
</div>
